import React, { useMemo } from "react";
import {
  FormAutocomplete,
  formClasses,
  labelClasses,
  LabeledAutocomplete,
} from "../../../styles/AutocompleteStyles";
import { TextField } from "@mui/material";
export interface Props {
  onChange: (newValue: number) => void;
  value: number | null;
  onKeyDown:
    | ((
        event: React.KeyboardEvent<HTMLDivElement> & {
          defaultMuiPrevented?: boolean;
        }
      ) => void)
    | undefined;
  poleNum: number;
  autoFocus?: boolean;

  label?: string;
}
const PoleNumComponent = ({
  label,
  onChange,
  onKeyDown,
  autoFocus,
  value,
  poleNum,
}: Props) => {
  let commonAutocompleteClassName = label
    ? labelClasses.inputRoot
    : formClasses.inputRoot;
  let commonTextFieldClassName = label
    ? labelClasses.formControlRoot
    : formClasses.formControlRoot;
  const Autocomplete = label ? LabeledAutocomplete : FormAutocomplete;
  const poleNumOptions = useMemo(() => {
    return Array.from({ length: poleNum + 1 }, (_, i) => i);
  }, [poleNum]);

  return (
    <Autocomplete
      className={commonAutocompleteClassName}
      options={poleNumOptions}
      onKeyDown={onKeyDown}
      value={value}
      openOnFocus
      forcePopupIcon
      onChange={(e, newValue) => {
        onChange(newValue as number);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          label={label}
          autoFocus={autoFocus}
          className={commonTextFieldClassName}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
      )}
    />
  );
};

export default PoleNumComponent;
